// Maps the engine's 7 internal categories / tier + risk_level + confidence onto
// the 4 renter-facing buckets (design §2). Returns label/emoji/meaning/className.
export function bucketFor(f) {
  if (f.tier === 'violation' && f.risk_level === 'high')
    return {
      key: 'red',
      label: '🔴 Red flag',
      emoji: '🔴',
      meaning: 'This could be a real problem. Worth getting checked before you sign.',
      className: 'ring-red-200 bg-red-50 dark:ring-red-900 dark:bg-red-950/40',
    };
  if (f.risk_level === 'high' || f.tier === 'violation')
    return {
      key: 'orange',
      label: '🟠 Watch out',
      emoji: '🟠',
      meaning: "This leans in the landlord's favor — make sure you're okay with it.",
      className: 'ring-orange-200 bg-orange-50 dark:ring-orange-900 dark:bg-orange-950/40',
    };
  if (f.confidence !== undefined && f.confidence < 0.6)
    return {
      key: 'yellow',
      label: '🟡 Unclear',
      emoji: '🟡',
      meaning: "We couldn't tell for sure. Ask your landlord — or a lawyer — about this.",
      className: 'ring-amber-200 bg-amber-50 dark:ring-amber-900 dark:bg-amber-950/40',
    };
  return {
    key: 'orange',
    label: '🟠 Watch out',
    emoji: '🟠',
    meaning: "This leans in the landlord's favor — make sure you're okay with it.",
    className: 'ring-orange-200 bg-orange-50 dark:ring-orange-900 dark:bg-orange-950/40',
  };
}
